import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'light' | 'dark';

interface ThemeState {
	theme: Theme;
	toggle: () => void;
	set: (theme: Theme) => void;
}

/**
 * Theme store (per 10-app-shell-spec.md §"Theme toggle"). Persisted via zustand's
 * `persist` middleware under `admin-v2-theme`. The `data-theme` attribute is set
 * synchronously in main.tsx before React mounts (no flash); this store keeps it in
 * sync on toggle and re-applies it on rehydration.
 */
export const useThemeStore = create<ThemeState>()(
	persist(
		(set, get) => ({
			theme: 'light',
			toggle: () => {
				const next: Theme = get().theme === 'light' ? 'dark' : 'light';
				document.documentElement.setAttribute('data-theme', next);
				set({ theme: next });
			},
			set: theme => {
				document.documentElement.setAttribute('data-theme', theme);
				set({ theme });
			}
		}),
		{
			name: 'admin-v2-theme',
			onRehydrateStorage: () => state => {
				if (state) document.documentElement.setAttribute('data-theme', state.theme);
			}
		}
	)
);
